// extracted by mini-css-extract-plugin
export default {"melodyVideo":"SI-z","isFullWidth":"TI-z","landingPageVideo":"UI-z","play":"VI-z","iframeVideo":"WI-z","playHidden":"XI-z","fullwidth":"YI-z"};